// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2-r8b","sendOtp":"AuthorizeToLogin_sendOtp__1KBI9"};